export const MARGINS = {
  none: "0px",
  small: "12px",
  middle: "24px",
} as const;
